export default __webpack_public_path__ + "static/media/calendar.164b3226.svg";